<template>
  <div class="product_list" v-loading="loading">
    <div class="s_wrapper">
      <el-select class="s_input" v-model="orderStatus" placeholder="请选择" clearable @change="onSearch">
        <el-option v-for="(item, index) in statusOptions" :key="index" :label="item" :value="index"></el-option>
      </el-select>
      <el-date-picker class="" v-model="times" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable @change="changeTimes"></el-date-picker>
      <!-- <el-button type="primary" @click="onCollate">核销</el-button> -->
      <el-button type="primary" @click="onOrder">开单</el-button>
      <el-button style="width: 55px" type="primary" plain icon="el-icon-refresh" @click="refresh"></el-button>
    </div>

    <productContentList :list="list" @cancel="cancelOrder" @confirm="orderPay" @select="onPaySelect" @refund="onRefund" />
    <el-empty v-if="list.length == 0" description="暂无数据"></el-empty>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :destroy-on-close="true">
      <!-- 订单核销 -->
      <!-- <div class="verify_code" v-if="dialogTitle == '订单核销'">
        <el-input v-model="verifyCode" placeholder="请输入核销码"></el-input>
      </div> -->

      <!-- 选择员工 -->
      <!-- <div class="dialog_employee" v-if="dialogTitle == '选择员工'">
        <div class="verify_code_order">
          <div class="order_info">
            <div>订单号：{{ order.orderCode }}</div>
            <div>用户姓名：{{ order.userName }}</div>
            <div>联系电话：{{ order.userPhone }}</div>
          </div>
          <div class="project">项目名称：{{ order.projectName }}</div>
        </div>
        <el-tabs v-model="departmentId" @tab-click="handleClickEmployeeTabs">
          <el-tab-pane v-for="(item, index) in staffDepartmentList" :key="index" :label="item.departmentName" :name="item.departmentId"></el-tab-pane>
        </el-tabs>
        <div class="employee_list" v-loading="employeeloading">
          <div class="employee_list_item" v-for="(item, index) in staffList" :key="index" :class="employeeId == item.employeeId ? 'employee_ac' : ''" @click="changeStaff(item)">
            <div class="icon">
              <i class="el-icon-success" v-if="employeeId == item.employeeId"></i>
              <i class="el-icon-circle-check" v-else></i>
            </div>
            <div class="avatar">
              <img :src="item.avatarUrl || require('@/assets/img/staff.png')" width="60" height="60" />
            </div>
            <div class="info">
              <div class="name overt">{{ item.employeeName }}</div>
              <div class="code overt">员工编号：{{ item.employeeCode }}</div>
              <div class="num">今日服务次数：{{ item.count }}次</div>
            </div>
          </div>
        </div>
        <el-pagination class="pg_input" background @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page.sync="currentPage2" :page-size="pageSize2" :page-sizes="pageSizeArr2" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount2"></el-pagination>
      </div> -->

      <!-- 支付 -->
      <div class="dialog_member" v-if="dialogTitle == '支付'">
        <el-form :model="payobj" ref="payobj" label-width="150px" class="payobj">
          <el-row type="flex" justify="center">
            <el-form-item label="支付方式">
              <el-select v-model="payobj.payType" @change="changeSelect">
                <el-option label="微信" value="1"></el-option>
                <el-option label="现金支付" value="2"></el-option>
                <el-option v-if="payobj.isVip == 1" label="会员卡支付" value="3"></el-option>
                <el-option label="收款二维码" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center">
            <el-form-item label="付款金额(元)">
              <el-input v-model="payobj.orderAmount" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="payobj.payType == 3">
            <el-form-item label="会员卡号">
              <el-input v-model="payobj.memberCode" placeholder="未选择会员卡" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="payobj.payType == 3">
            <el-form-item label="账户余额(元)">
              <el-input v-model="payobj.balance" placeholder="未选择会员卡" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="payobj.payType == 1">
            <el-form-item label="付款码">
              <el-input ref="paycode" v-model="payobj.payCode" placeholder="请扫描付款码"></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="payobj.payType == 4 && qrurl">
            <vue-qr :correctLevel="3" :autoColor="false" colorDark="#1777D9" :text="qrurl" :size="250"></vue-qr>
          </el-row>
        </el-form>
      </div>

      <span slot="footer" v-if="dialogTitle == '订单核销'">
        <el-button @click="cancelVerifyCode">取 消</el-button>
        <el-button type="primary" @click="confirmVerifyCode" :loading="btnloading">核 销</el-button>
      </span>
      <span slot="footer" v-if="dialogTitle == '选择员工'">
        <el-button @click="cancelEmployee">上一步</el-button>
        <el-button type="primary" @click="confirmEmployee" :loading="btnloading">确 定</el-button>
      </span>
      <span slot="footer" v-if="dialogTitle == '支付' && payobj.payType != 4">
        <el-button @click="cancelPay">取 消</el-button>
        <el-button type="primary" @click="onPay" :loading="btnloading">确 定</el-button>
      </span>
      <span slot="footer" v-if="dialogTitle == '支付' && payobj.payType == 4">
        <el-button @click="cancelPay">取 消</el-button>
        <el-button type="primary" @click="onPayNew" :loading="btnloading">我已支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import productContentList from "../../components/productContentList.vue"
import VueQr from "vue-qr"
export default {
  components: { productContentList, VueQr },
  data() {
    return {
      loading: false,
      employeeloading: false,
      list: [],
      orderStatus: "",
      times: [],
      startTime: "",
      endTime: "",
      statusOptions: { 0: "待结账", 4: "已结账", 5: "已作废", 6: "支付中" },
      dialogVisible: false,
      btnloading: false,
      dialogTitle: "订单核销",
      verifyCode: "",
      employeeId: "",
      employeeName: "",
      departmentId: "0",
      staffList: [],
      staffDepartmentList: [],
      order: {},
      payobj: {
        payCode: "",
        id: "",
        payType: "",
        balance: "",
        memberCode: "",
        orderAmount: "",
      },
      qrurl: "",
      currentPage: 1, // 当前页码
      pageSize: 12, // 每页显示的行数
      pageSizeArr: [12, 24, 60], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）

      // 员工分页
      currentPage2: 1, // 当前页码
      pageSize2: 9, // 每页显示的行数
      pageSizeArr2: [9, 18, 54], // 每页显示的行数(可选)
      totalItemsCount2: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.times[0] = this.getTodayDate()
    this.times[1] = this.getTodayDate()
    this.startTime = this.getTodayDate()
    this.endTime = this.getTodayDate()
    this.getList()
  },
  methods: {
    getList() {
      let storeId = this.$store.state.userInfo.bizId
      this.loading = true
      this.$axios
        .get(this.$api.cashier_orderselect_product_info, {
          params: {
            storeId,
            startTime: this.startTime,
            endTime: this.endTime,
            orderStatus: this.orderStatus, // 订单状态：0: "待结账", 4: "已结账", 5: "已作废"
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          this.list = res.result.list || []
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 员工列表
    getStaffList() {
      this.employeeloading = true
      this.$axios
        .get(this.$api.employeeInfoselectEmployee, {
          params: {
            parentId: this.departmentId == "0" ? "" : this.departmentId,
            storeId: this.$store.state.userInfo.bizId,
            page: this.currentPage2,
            pageSize: this.pageSize2,
          },
        })
        .then(res => {
          this.staffList = res.result.list
          this.totalItemsCount2 = res.result.totalCount
          this.employeeloading = false
        })
        .catch(err => {
          this.employeeloading = false
          this.$message.error(err.desc)
        })
    },
    // 员工部门
    getStaffDepartmentList() {
      this.$axios
        .get(this.$api.departmentInfoselectParentDepartment)
        .then(res => {
          let list = res.result.map(e => {
            return {
              ...e,
              departmentId: e.departmentId.toString(),
            }
          })
          list.unshift({ departmentId: "0", departmentName: "全部" })
          this.staffDepartmentList = list
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 切换员工部门
    handleClickEmployeeTabs() {
      this.staffList = []
      this.currentPage2 = 1
      this.getStaffList()
    },
    // 切换员工
    changeStaff(e) {
      this.employeeId = e.employeeId
      this.employeeName = e.employeeName
    },
    // 核销
    onCollate() {
      this.dialogTitle = "订单核销"
      this.dialogVisible = true
    },
    // 取消核销
    cancelVerifyCode() {
      this.verifyCode = ""
      this.dialogVisible = false
    },
    // 确定核销
    confirmVerifyCode() {
      this.btnloading = true
      this.$axios
        .get(this.$api.cashier_orderverification_appointment, {
          params: {
            verifyCode: this.verifyCode,
            storeId: this.$store.state.userInfo.bizId,
          },
        })
        .then(res => {
          this.getStaffList()
          this.getStaffDepartmentList()
          this.order = res.result
          this.dialogTitle = "选择员工"
          this.btnloading = false
        })
        .catch(err => {
          this.btnloading = false
          this.$message.error(err.desc)
        })
    },
    // 取消员工，返回上一步
    cancelEmployee() {
      this.employeeId = ""
      this.employeeName = ""
      this.order = {}
      this.dialogTitle = "订单核销"
    },
    // 确定员工
    confirmEmployee() {
      this.btnloading = true
      this.$axios
        .post(this.$api.cashier_orderchoice_technician, {
          verifyCode: this.verifyCode,
          storeId: this.$store.state.userInfo.bizId,
          employeeId: this.employeeId,
          projectOrderId: this.order.projectOrderId,
        })
        .then(res => {
          this.btnloading = false
          this.dialogVisible = false
          this.$message.success("核销成功")
        })
        .catch(err => {
          this.btnloading = false
          this.$message.error(err.desc)
        })
    },
    // 筛选日期
    changeTimes() {
      this.startTime = this.times ? this.times[0] || "" : ""
      this.endTime = this.times ? this.times[1] || "" : ""
      this.getList()
    },
    onOrder() {
      this.$router.push({ name: "addProductOrder" })
    },
    onSearch() {
      this.list = []
      this.currentPage = 1
      this.getList()
    },
    //  //获取商品支付二维码
    // productQRCode(){
    //     this.$axios
    //     .post(this.$api.product_QRCode_pay_order, {
    //        title: "商品二维码主动支付",
    //       orderCode: this.payobj.orderCode,
    //       payAmount: this.payobj.orderAmount, // 支付金额
    //     })
    //     .then(res => {
    //        if(res.code==100){
    //       this.qrurl = res.result.qrurl
    //       this.btnloading = false
    //       }else{
    //       this.$message.error(res.desc)
    //       }
    //     })
    //     .catch(err => {
    //       this.$message.error(err.desc)
    //     })
    // },
    // 支付二维码-跳转H5支付
    productQRCode() {
      this.btnloading = false
      const { orderAmount, id, orderCode } = this.payobj
      this.qrurl = `https://producth5.ganmiaoedu.com/pagesA/otherPay/otherPay?payPrice=${orderAmount}&sourceId=${id}&sourceNum=${orderCode}&sourceType=${2}`
    },
    changeSelect(e) {
      if (e == 4) {
        this.btnloading = true
        this.productQRCode()
      }
      this.$nextTick(() => {
        if (e == 1) {
          this.$refs.paycode.focus()
        }
      })
    },
    // 退款
    onRefund(e) {
      this.$confirm("确认退款吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.loading = true
          this.$axios
            .post(this.$api.cashier_orderwechat_code_cancel_product_order, {
              orderCode: e.orderCode,
            })
            .then(res => {
              this.$message.success("退款成功")
              setTimeout(() => {
                this.getList()
                this.loading = false
              }, 1500)
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.desc)
            })
        })
        .catch(() => {})
    },
    // 重复支付时查询支付状态用
    onPaySelect(e) {
      this.loading = true
      this.$axios
        .post(this.$api.cashier_orderselect_pay_product_order, {
          orderCode: e.orderCode,
        })
        .then(res => {
          this.$message.success("更新成功")
          setTimeout(() => {
            this.getList()
            this.loading = false
          }, 1500)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 取消订单
    cancelOrder(e) {
      this.$confirm("即将取消该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.cashier_orderbank_cancel_order, {
              orderId: e.orderId,
            })
            .then(res => {
              this.$message.success("取消成功")
              setTimeout(() => {
                this.getList()
              }, 1000)
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {})
    },
    // 付款弹窗
    orderPay(e) {
      // if (e.isVip == 1) {
      //   // 会员订单先查会员余额
      //   this.$axios
      //     .get(this.$api.memberInfopageList, {
      //       params: {
      //         memberCode: e.memberCode,
      //       },
      //     })
      //     .then(res => {
      //       let obj = res.result.list[0]
      //       this.payobj = {
      //         id: e.orderId,
      //         isVip: 1,
      //         balance: obj.balance, // 余额
      //         memberCode: obj.memberCode, // 卡号
      //         orderAmount: e.orderAmount, // 余额
      //       }
      //       this.dialogTitle = "支付"
      //       this.dialogVisible = true
      //     })
      //     .catch(err => {
      //       this.$message.error(err.desc)
      //     })
      // } else {
      this.payobj = {
        id: e.orderId,
        orderCode: e.orderCode,
        isVip: 2,
        orderAmount: e.orderAmount,
      }
      this.dialogTitle = "支付"
      this.dialogVisible = true
      // }
    },
    // 取消付款
    cancelPay() {
      this.payobj = {
        payCode: "",
        id: "",
        payType: "",
        balance: "",
        memberCode: "",
        orderAmount: "",
      }
      this.dialogVisible = false
    },

    // 付款
    onPay() {
      let api = ""
      let params = {}
      if (!this.payobj.payType) {
        this.$message.error("请选择支付方式")
        return
      }

      if (this.payobj.payType == 1) {
        // api = this.$api.cashier_orderpayment_code_pay_product_order
        // params = {
        //   userPayCode: this.payobj.payCode,
        //   orderCode: this.payobj.orderCode,
        //   // payAmount: 0.01, // 支付金额
        //   payAmount: this.payobj.orderAmount, // 支付金额
        // }
        api = this.$api.cashier_orderhuifuReversePay
        params = {
          title: "商品二维码主动支付",
          userId: 0,
          payType: Number(this.payobj.payType),
          sourceNum: this.payobj.orderCode,
          userPayCode: this.payobj.payCode,
          sourceType: 2,
          sourceId: this.payobj.id,
          payPrice: this.payobj.orderAmount, // 支付金额
          // payAmount: 0.01, // 支付金额
        }
      } else {
        api = this.$api.cashier_orderproduct_pay_order
        params = {
          // memberCode: this.payobj.memberCode,
          orderId: this.payobj.id,
          payType: Number(this.payobj.payType),
          orderAmount: this.payobj.orderAmount, // 订单金额
        }
      }

      this.btnloading = true
      this.$axios
        .post(api, params)
        .then(res => {
          this.$message.success("付款成功")
          this.btnloading = false
          this.dialogVisible = false
          this.getList()
        })
        .catch(err => {
          this.btnloading = false
          this.$message.error(err.desc)
        })
    },
    //扫码付款
    onPayNew() {
      this.btnloading = false
      this.dialogVisible = false
      this.getList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.list = []
      this.pageSize = e
      this.getList()
    },
    // 换页
    handleCurrentChange(e) {
      this.list = []
      this.currentPage = e
      this.getList()
    },
    // 切换每页显示的条数 - 员工
    handleSizeChange2(e) {
      this.staffList = []
      this.pageSize2 = e
      this.getStaffList()
    },
    // 换页 - 员工
    handleCurrentChange2(e) {
      this.staffList = []
      this.currentPage2 = e
      this.getStaffList()
    },
    refresh() {
      this.list = []
      this.getList()
    },
  },
}
</script>

<style scoped lang="scss">
.product_list {
  .s_wrapper {
    .el-button {
      width: 110px;
    }
  }
  .verify_code {
    display: flex;
    justify-content: center;
    .el-button {
      margin-left: 10px;
    }
  }
  .dialog_employee {
    .verify_code_order {
      display: flex;
      flex-direction: column;
      color: #707070;
      padding: 15px;
      margin-bottom: 20px;
      background: rgba(3, 16, 14, 0.05);
      border-radius: 10px 10px 10px 10px;
      .order_info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
      }
    }
    .employee_list {
      display: flex;
      flex-wrap: wrap;
      .employee_list_item {
        display: flex;
        align-items: center;
        width: 295px;
        height: 95px;
        padding: 10px;
        margin-right: 15px;
        margin-bottom: 15px;
        font-size: 14px;
        color: #707070;
        background: #fff;
        box-shadow: 0px 3px 30px 1px rgba(38, 30, 3, 0.04);
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #e8e8e8;
        box-sizing: border-box;
        cursor: pointer;
        .icon {
          font-size: 20px;
        }
        .avatar img {
          border-radius: 50%;
          margin: 0 10px;
        }
        .info {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          height: 100%;
          .name {
            color: #0f1c40;
            font-weight: bold;
          }
          .overt {
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .employee_ac {
        color: $themes;
        border-color: $themes;
      }
    }
  }
}
</style>
